import React from 'react';
import { GlobeIcon, InstagramIcon, MailIcon } from 'lucide-react';
const links = [{
  label: 'El programa',
  href: '#programa'
}, {
  label: 'Bonos',
  href: '#bonos'
}, {
  label: 'Precio',
  href: '#precio'
}, {
  label: 'Preguntas',
  href: '#faq'
}];
export function Footer() {
  return <footer className="bg-navy py-14" data-id="element-106" data-mp="2a609q1i48raw">
      <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-107" data-mp="2a69yjlrfcsf0">
        <div className="grid gap-10 lg:grid-cols-3 lg:items-start" data-id="element-108" data-mp="1mfmnwsq4joor">
          <div data-id="element-109" data-mp="1mdtfb7vyaue4">
            <span className="text-[13px] font-bold uppercase tracking-[0.2em] text-ice" data-id="element-110" data-mp="1hhbeuk7nli7l">
              Atleta<span className="text-gold" data-id="element-111" data-mp="1w5z6wgiaj9ss"> Corporativo™</span>
            </span>
            <p className="mt-4 max-w-xs text-[15px] leading-[1.7] text-cool" data-id="element-112" data-mp="1w823jjdy816h">
              El sistema de biohacking corporativo para profesionales de
              oficina.
            </p>
          </div>

          <nav aria-label="Secciones" className="lg:justify-self-center" data-id="element-113" data-mp="13nbs1itw0r05">
            <ul className="flex flex-wrap gap-x-7 gap-y-3" data-id="element-114" data-mp="yqbj905nla5c">
              {links.map(link => <li key={link.href} data-id="element-115" data-mp="1ehap4u561g4r">
                  <a href={link.href} className="text-[13px] font-medium uppercase tracking-[0.1em] text-cool transition-colors duration-200 ease-smooth hover:text-gold" data-id="element-116" data-mp="1eg9dook8mrmi">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <ul className="space-y-2.5 text-[14px] text-cool lg:justify-self-end" data-id="element-117" data-mp="1s8p9b4at7nde">
            <li data-id="element-118" data-mp="vkj9cuou1j5g">
              <a href="mailto:soporte@digilab.academy" className="inline-flex items-center gap-2.5 transition-colors duration-200 ease-smooth hover:text-gold" data-id="element-119" data-mp="vl141mvujpb9">
                <MailIcon className="h-4 w-4 shrink-0 text-gold" strokeWidth={1.75} aria-hidden="true" data-id="element-120" data-mp="14jmstzrww0kh" />
                soporte@digilab.academy
              </a>
            </li>
            <li data-id="element-121" data-mp="2fzbgktczp3mc">
              <a href="https://instagram.com/atletacorporativo" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 transition-colors duration-200 ease-smooth hover:text-gold" data-id="element-122" data-mp="2fzup5jgr2fnp">
                <InstagramIcon className="h-4 w-4 shrink-0 text-gold" strokeWidth={1.75} aria-hidden="true" data-id="element-123" data-mp="1v8z80r3zal9w" />
                @atletacorporativo
              </a>
            </li>
            <li data-id="element-124" data-mp="258q0yocw4s7v">
              <a href="https://atletacorporativo.digilab.academy" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 transition-colors duration-200 ease-smooth hover:text-gold" data-id="element-125" data-mp="25756eyqkt9a0">
                <GlobeIcon className="h-4 w-4 shrink-0 text-gold" strokeWidth={1.75} aria-hidden="true" data-id="element-126" data-mp="1ckamc2xo8bx2" />
                atletacorporativo.digilab.academy
              </a>
            </li>
          </ul>
        </div>

        <div className="mt-12 border-t border-line pt-8" data-id="element-127" data-mp="1man81yh82b4s">
          <p className="text-[13px] leading-[1.7] text-cool" data-id="element-128" data-mp="1hic5env3kb8j">
            © {new Date().getFullYear()} Atleta Corporativo™. Porque rendir al
            máximo en tu carrera no debería costarte la salud, la energía y los
            años con tu familia. Producto digital — no reemplaza consulta médica
            profesional.
          </p>
        </div>
      </div>
    </footer>;
}